import {
  UtensilsCrossed,
  Coffee,
  Pill,
  Bus,
  Hotel,
  CircleParking,
} from "lucide-react";
import type { POICategory } from "./types";

export const POI_COLORS: Record<POICategory, string> = {
  restaurant: "#EF4444",
  cafe: "#92400E",
  pharmacy: "#22C55E",
  transport: "#3B82F6",
  hotel: "#8B5CF6",
  parking: "#6B7280",
};

export const POI_ICONS: Record<
  POICategory,
  React.FC<{ className?: string; style?: React.CSSProperties }>
> = {
  restaurant: UtensilsCrossed,
  cafe: Coffee,
  pharmacy: Pill,
  transport: Bus,
  hotel: Hotel,
  parking: CircleParking,
};
